import { ANALYTICS_ENDPOINT } from "./endpoints";
import { AnalyticsData } from "./types";
import { fetcher } from "./utils";

export const updateAnalyticsByTestId = async (
    test_id: string,
    data: Partial<AnalyticsData>
) => {
    const resData = await fetcher(ANALYTICS_ENDPOINT, {
        method: "PUT",
        params: { test_id },
        data,
    });

    return resData;
};
